import React from 'react';
import ReactDOM from 'react-dom';
/*import 'menuc-static/vendor/responsivegridsystem/html5reset.css';
import 'menuc-static/vendor/responsivegridsystem/col.css';
import 'menuc-static/vendor/responsivegridsystem/2cols.css';
import 'menuc-static/vendor/responsivegridsystem/3cols.css';
import 'menuc-static/vendor/responsivegridsystem/4cols.css';
import 'menuc-static/vendor/responsivegridsystem/5cols.css';
import 'menuc-static/vendor/responsivegridsystem/6cols.css';
import 'menuc-static/vendor/responsivegridsystem/7cols.css';
import 'menuc-static/vendor/responsivegridsystem/8cols.css';
import 'menuc-static/vendor/responsivegridsystem/9cols.css';
import 'menuc-static/vendor/responsivegridsystem/10cols.css';
import 'menuc-static/vendor/responsivegridsystem/11cols.css';
import 'menuc-static/vendor/responsivegridsystem/12cols.css';
import 'menuc-static/vendor/font-awesome-4.7.0/css/font-awesome.min.css';

import 'menuc-static/css/menuc.scss';*/

import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';


ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js